import { schema } from 'normalizr';

import extractLineNumberFromSku from 'utils/extract-linenumber-from-sku';

const productConflictEntity = new schema.Entity(
  'productConflicts',
  {},
  {
    idAttribute: ({ productId, id, lineNumber }) => {
      if (productId) return extractLineNumberFromSku(productId);
      return lineNumber || extractLineNumberFromSku(id);
    },
  },
);
const promotionEntity = new schema.Entity(
  'promotions',
  {},
  {
    idAttribute: 'promotionId',
    processStrategy: (value, parent) => {
      const { promotionId, wasDisplayPrice = null } = value;

      if (wasDisplayPrice) {
        const { previousPricing } = parent;

        parent.previousPricing = {
          ...previousPricing,
          [promotionId]: wasDisplayPrice,
        };
      }

      return value;
    },
  },
);
const trolleyConflictEntity = new schema.Entity('trolleyConflicts', {}, { idAttribute: 'itemId' });
const productEntity = new schema.Entity(
  'products',
  {
    conflicts: [productConflictEntity],
    promotions: [promotionEntity],
  },
  {
    idAttribute: ({ id, lineNumber }) => lineNumber || extractLineNumberFromSku(id),
  },
);
const orderEntity = new schema.Entity('orders', {}, { idAttribute: 'orderId' });
const shoppingListEntity = new schema.Entity('shoppingLists', {
  shoppingListId: {
    items: [
      {
        item: productEntity,
      },
    ],
  },
});

const aemChildComponentSchema = new schema.Object({
  items: [
    {
      searchProduct: productEntity,
    },
  ],
});
aemChildComponentSchema.define({
  childComponents: [aemChildComponentSchema],
  paragraphSystem: {
    childComponents: [aemChildComponentSchema],
  },
});

export const cmsMultiGridSchema = {
  nodes: [aemChildComponentSchema],
};

const locationsSchema = new schema.Values([aemChildComponentSchema]);

export const experienceFragmentSchema = {
  conflicts: [productConflictEntity],
  locations: locationsSchema,
};

export const componentsAndProductsSchema = {
  content: locationsSchema,
  locations: locationsSchema,
  componentsAndProducts: [
    {
      searchProduct: productEntity,
      aemComponent: aemChildComponentSchema,
    },
  ],
};

export const componentsAndProductsAndRecommendationsSchema = {
  ...componentsAndProductsSchema,
  recommendations: [
    {
      searchProduct: productEntity,
    },
  ],
};

export const suggestionsSchema = {
  suggestions: [
    {
      searchProduct: productEntity,
    },
  ],
};

export const intelligentShoppingExperienceSuggestionsSchema = {
  suggestions: [
    {
      candidates: [{ searchProduct: productEntity }],
    },
  ],
};

const customerOrderEntity = new schema.Entity(
  'customerOrders',
  {},
  { idAttribute: 'customerOrderId' },
);

export const customerOrdersSchema = {
  content: [customerOrderEntity],
};

export const legacyProductsSchema = {
  products: [
    {
      searchProduct: productEntity,
    },
  ],
};

export const legacyProductsAndRecommendationsSchema = {
  ...legacyProductsSchema,
  recommendations: [
    {
      searchProduct: productEntity,
    },
  ],
};

export const productsSchema = {
  products: [productEntity],
};

export const bundleSchema = {
  productCollections: [legacyProductsSchema],
};

export const promotionsSchema = [promotionEntity];

export const trolleySchema = {
  products: [productEntity],
};

export const ordersSchema = {
  legacyOrderSummaryResponse: {
    orderSummaries: [orderEntity],
  },
};

export const shoppingListSchema = shoppingListEntity;
export const shoppingListsSchema = [shoppingListEntity];

export const productConflictListSchema = [productConflictEntity];
export const trolleyConflictListSchema = [trolleyConflictEntity];

export const BUNDLE_SCHEMA = 'bundleSchema';
export const CMS_MULTI_GRID_SCHEMA = 'cmsMultiGridSchema';
export const COMPONENTS_AND_PRODUCTS_SCHEMA = 'componentsAndProductsSchema';
export const COMPONENTS_AND_PRODUCTS_AND_RECOMMENDATIONS_SCHEMA =
  'componentsAndProductsAndRecommendationsSchema';
export const CUSTOMER_ORDERS_SCHEMA = 'customerOrdersSchema';
export const EXPERIENCE_FRAGMENT_SCHEMA = 'experienceFragmentSchema';
export const INTELLIGENT_SHOPPING_EXPERIENCE_SUGGESTIONS_SCHEMA =
  'intelligentShoppingExperienceSuggestionsSchema';
export const PRODUCT_CONFLICT_LIST_SCHEMA = 'productConflictListSchema';
export const PRODUCTS_SCHEMA = 'productsSchema';
export const LEGACY_PRODUCTS_SCHEMA = 'legacyProductsSchema';
export const LEGACY_PRODUCTS_AND_RECOMMENDATIONS_SCHEMA = 'legacyProductsAndRecommendationsSchema';
export const ORDERS_SCHEMA = 'ordersSchema';
export const PROMOTIONS_SCHEMA = 'promotionsSchema';
export const SHOPPING_LIST_SCHEMA = 'shoppingListSchema';
export const SHOPPING_LISTS_SCHEMA = 'shoppingListsSchema';
export const SUGGESTIONS_SCHEMA = 'suggestionsSchema';
export const TROLLEY_CONFLICT_LIST_SCHEMA = 'trolleyConflictListSchema';
export const TROLLEY_SCHEMA = 'trolleySchema';

export const schemas = {
  bundleSchema,
  cmsMultiGridSchema,
  componentsAndProductsSchema,
  componentsAndProductsAndRecommendationsSchema,
  customerOrdersSchema,
  experienceFragmentSchema,
  intelligentShoppingExperienceSuggestionsSchema,
  legacyProductsSchema,
  legacyProductsAndRecommendationsSchema,
  ordersSchema,
  productConflictListSchema,
  productsSchema,
  promotionsSchema,
  shoppingListSchema,
  shoppingListsSchema,
  suggestionsSchema,
  trolleyConflictListSchema,
  trolleySchema,
};
